import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useStore = create(
  persist(
    (set) => ({
      authToken: null,
      setAuthToken: (token) => set(() => ({ authToken: token })),
      imageData: null,
      setImageData: (imageData) => set(() => ({ imageData: imageData })),
      profile: null,
      setProfile: (profile) => set(() => ({ profile })),
      pluginData: null,
      setPluginData: (pluginData) => set(() => ({ pluginData })),
      logout: () =>
        set(() => ({ authToken: null, pluginData: null, profile: null })),
      galleryImages: {},
      // setGalleryImages: (images) => set(() => ({ galleryImages: images })),
      // https://github.com/pmndrs/zustand/discussions/2368
      // also allow an updater function
      setGalleryImages: (images) =>
        set((state) => ({
          galleryImages:
            typeof images === "function" ? images(state.galleryImages) : images,
        })),
      jobs: [],
      setJobs: (jobs) =>
        set((state) => ({
          jobs: typeof jobs === "function" ? jobs(state.jobs) : jobs,
        })),
      generatorConfig: null,
      setGeneratorConfig: (config) => set(() => ({ generatorConfig: config })),
      // null = unset (fall back to plan-based default: open for paid users).
      genRailOpen: null,
      setGenRailOpen: (open) => set(() => ({ genRailOpen: open })),
      selectedImages: [],
      setSelectedImages: (images) => set(() => ({ selectedImages: images })),
      showSelectedOnly: false,
      setShowSelectedOnly: (show) => set(() => ({ showSelectedOnly: show })),
    }),
    {
      name: "photovortex",
      partialize: (state) => ({
        authToken: state.authToken,
        pluginData: state.pluginData,
        profile: state.profile,
        genRailOpen: state.genRailOpen,
      }),
    }
  )
);
